import './Footer6.css';

import React from 'react';
import getIcons from '../../functions/getIcons/getIcons';

const Footer6 = ({ operator, t }) => {
  return (
    <div
      className="footer6"
      style={{
        background:
          operator && operator.color_codes && operator.color_codes.sub_footer_color
            ? operator.color_codes.sub_footer_color
            : '',
      }}
    >
      <style>
        .footer-input::placeholder, textarea::placeholder {'{'}
        font-size: 16px; font-weight: bold
        {'}'}
        .footer-input {'{'}
        font-size: 14px
        {'}'}
      </style>
      <div className=" text-white">
        <div
          className="d-flex justify-content-center py-2"
          style={{
            background:
              operator && operator.color_codes && operator.color_codes.footer_color
                ? operator.color_codes.footer_color
                : '',
          }}
        >
          <a href="/">
            <img src={operator.header_logo} alt="DIS" className="logo2" id="main-logo" />
          </a>
        </div>
        <div className="content-container d-flex row py-4">
          <div className="boxes px-3 col border-right">
            <div className="font-14px text-justify" style={{ lineHeight: 1.3 }}>
            San Andrés es una empresa de viajes dedicada a darte una experiencia cómoda en todo momento. Queremos entregarte un servicio de calidad a través de nuestra flota y personal completamente preparados para tu satisfacción.
              <br />
              <br />A través de nuestros viajes deseamos ganar la verdadera confianza y confort de nuestros clientes.
            </div>
            <div className="d-flex justify-between text-justify mt-2 ">
              <div style={{ width: '0%' }}>
                <a href="https://www.facebook.com/pullmansanandres.cl" target="_blank">
                  <span className="san-andreas-facebook1 mx-1"></span>
                </a>
                <a href="https://www.instagram.com/pullmansanandres.cl/" target="_blank">
                  <span className="san-andreas-insta1 mx-1"></span>
                </a>
              </div>
              <div style={{ width: '100%', lineHeight: 1.2 }}>

              <div className="font-14px" style={{ marginBottom: '13px' }}>
                  <span className="bold-text">Razón social:</span> Transporte Transmat Limitada
                </div>

                <div className="font-14px" style={{ marginBottom: '13px' }}>
                  <span className="bold-text">Representante legal:</span> Rodrigo Challapa Gómez
                </div>

                <div className="font-14px" style={{ marginBottom: '13px' }}>
                  <span className="bold-text">Direccion:</span>  Patricio Lynch s/n, Terminal de Buses Of. 16, Iquique. Región de Tarapacá.
                </div>

                <div className="font-14px" style={{ marginBottom: '13px' }}>
                  <span className="bold-text">Correo:</span> contacto@transportestransmat.cl
                </div>

                <div className="font-14px" style={{ marginBottom: '13px' }}>
                  <span className="bold-text">Teléfono:</span> +56933798168
                </div>
              </div>
            </div>
          </div>
          <div className="boxes px-3 col border-right">
            <div className="font-20px bold-text mb-2">Sucursales:</div>
            <ul className="font-14px bold-text" style={{ lineHeight: 1.2 }}>
              <li className="mb-1">Arica - Terminal Rodoviario.</li>
              <li className="mb-1">Iquique - Terminal Rodoviario.</li>
              <li className="mb-1">Antofagasta - Terminal Card. Carlos Oviedo.</li>
              <li className="mb-1">Calama - Terminal Rodoviario. Santiago - Terminal San Borja.</li>
              <li className="mb-4">Santiago - Terminal San Borja.</li>
            </ul>
            <div className="font-20px bold-text  mb-2">Horario de Atención:</div>
            <div className="font-14px">Lunes a Viernes - 09:00 a 18:00 hrs.</div>
            <br/>
            <div className="font-14px bold-text color-white">
              <a href='https://www.ecommerceccs.cl/wp-content/uploads/2021/12/CBBPP-2021.pdf'target='blank' style={{color: 'white'}}>Código de buenas prácticas</a></div>
          </div>
          <div className="boxes px-3 col">
            <div className="font-20px bold-text mb-2 d-flex align-items-center">
              ¿Necesitas Ayuda?{' '}
              <img
                src="/assets/pullmanSanAndres/footer-whatsapp.svg"
                style={{ width: '25px', marginLeft: '10px' }}
                alt=""
              />
            </div>
            <div className="font-14px font-italic mb-2 ">
              Contáctanos al: {operator && operator.phone_number}
            </div>

            <form action="" className="w-100">
              <input
                type="text"
                placeholder="Nombre"
                className=" footer-input w-100  footer-input  mb-1"
              />
              <input
                type="text"
                placeholder="E-mail"
                className=" footer-input w-100  footer-input  mb-1"
              />
              <input
                type="text"
                placeholder="Numero de contacto"
                className=" footer-input w-100  footer-input  mb-1"
              />
              <textarea
                name=""
                placeholder="Mensaje"
                style={{ resize: 'none' }}
                id=""
                rows="4"
                className="footer-input w-100 mb-1"
              />
              <div className="d-flex justify-content-end">
                <button
                  className="px-4 py-2 font-14px text-white "
                  style={{
                    backgroundColor:
                      operator && operator.color_codes && operator.color_codes.primary_color
                        ? operator.color_codes.primary_color
                        : '',
                    border: 'none',
                  }}
                >
                  ENVIAR
                </button>
              </div>
            </form>
          </div>
        </div>
        <div className="poweredBy">
          <p className="font-12px">
            Pullman San Andrés 2024 © Todos los derechos reservados - Powered by{' '}
            <a href="https://kupos.cl" target="_blank" style={{ color: 'white' }}>
              kupos.cl
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer6;



// WEBPACK FOOTER //
// ./src/features/themes/common/footer/Footer6.js